export default __webpack_public_path__ + "static/media/arrow-icon.c3b3890d.svg";